/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  InstantiateTemplateDto,
  ProjectDto,
  SaveTemplateRequest,
  TemplateDTO,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Save
 */
export const postTemplate = (
  saveTemplateRequest: SaveTemplateRequest,
  signal?: AbortSignal,
) => {
  return customInstance<TemplateDTO>({
    url: `/template`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: saveTemplateRequest,
    signal,
  });
};

export const getPostTemplateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTemplate>>,
    TError,
    { data: SaveTemplateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTemplate>>,
  TError,
  { data: SaveTemplateRequest },
  TContext
> => {
  const mutationKey = ["postTemplate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTemplate>>,
    { data: SaveTemplateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postTemplate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTemplate>>
>;
export type PostTemplateMutationBody = SaveTemplateRequest;
export type PostTemplateMutationError = void;

/**
 * @summary Save
 */
export const usePostTemplate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTemplate>>,
      TError,
      { data: SaveTemplateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTemplate>>,
  TError,
  { data: SaveTemplateRequest },
  TContext
> => {
  const mutationOptions = getPostTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find All
 */
export const getTemplate = (signal?: AbortSignal) => {
  return customInstance<TemplateDTO[]>({
    url: `/template`,
    method: "GET",
    signal,
  });
};

export const getGetTemplateInfiniteQueryKey = () => {
  return ["infinite", `/template`] as const;
};

export const getGetTemplateQueryKey = () => {
  return [`/template`] as const;
};

export const getGetTemplateInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplate>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getTemplate>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTemplateInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({
    signal,
  }) => getTemplate(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplate>>
>;
export type GetTemplateInfiniteQueryError = void;

export function useGetTemplateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplate>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplate>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplate>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplate>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find All
 */

export function useGetTemplateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplate>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplate>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTemplateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({
    signal,
  }) => getTemplate(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplate>>
>;
export type GetTemplateQueryError = void;

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find All
 */

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find By Id
 */
export const getTemplateId = (id: number, signal?: AbortSignal) => {
  return customInstance<TemplateDTO>({
    url: `/template/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTemplateIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/template/${id}`] as const;
};

export const getGetTemplateIdQueryKey = (id?: number) => {
  return [`/template/${id}`] as const;
};

export const getGetTemplateIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplateId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplateId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTemplateIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateId>>> = ({
    signal,
  }) => getTemplateId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTemplateId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplateId>>
>;
export type GetTemplateIdInfiniteQueryError = void;

export function useGetTemplateIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplateId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplateId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getTemplateId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplateId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplateId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getTemplateId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplateId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplateId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetTemplateIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTemplateId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getTemplateId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTemplateIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplateId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplateId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTemplateIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateId>>> = ({
    signal,
  }) => getTemplateId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplateId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplateId>>
>;
export type GetTemplateIdQueryError = void;

export function useGetTemplateId<
  TData = Awaited<ReturnType<typeof getTemplateId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplateId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getTemplateId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateId<
  TData = Awaited<ReturnType<typeof getTemplateId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplateId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getTemplateId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateId<
  TData = Awaited<ReturnType<typeof getTemplateId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplateId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetTemplateId<
  TData = Awaited<ReturnType<typeof getTemplateId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplateId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteTemplateId = (id: number) => {
  return customInstance<boolean>({ url: `/template/${id}`, method: "DELETE" });
};

export const getDeleteTemplateIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplateId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTemplateId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTemplateId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTemplateId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTemplateId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTemplateId>>
>;

export type DeleteTemplateIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteTemplateId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTemplateId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTemplateId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTemplateIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Instantiate
 */
export const postTemplateIdInstantiate = (
  id: number,
  instantiateTemplateDto: InstantiateTemplateDto,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectDto>({
    url: `/template/${id}/instantiate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: instantiateTemplateDto,
    signal,
  });
};

export const getPostTemplateIdInstantiateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTemplateIdInstantiate>>,
    TError,
    { id: number; data: InstantiateTemplateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTemplateIdInstantiate>>,
  TError,
  { id: number; data: InstantiateTemplateDto },
  TContext
> => {
  const mutationKey = ["postTemplateIdInstantiate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTemplateIdInstantiate>>,
    { id: number; data: InstantiateTemplateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return postTemplateIdInstantiate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTemplateIdInstantiateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTemplateIdInstantiate>>
>;
export type PostTemplateIdInstantiateMutationBody = InstantiateTemplateDto;
export type PostTemplateIdInstantiateMutationError = void;

/**
 * @summary Instantiate
 */
export const usePostTemplateIdInstantiate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTemplateIdInstantiate>>,
      TError,
      { id: number; data: InstantiateTemplateDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTemplateIdInstantiate>>,
  TError,
  { id: number; data: InstantiateTemplateDto },
  TContext
> => {
  const mutationOptions = getPostTemplateIdInstantiateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
